import { useState, useEffect } from "react"
import { Redirect, Route } from "react-router-dom"
import SuspenseFallback from "./SuspenseFallback"
import AdminPanelLayout from "../components/AdminPanelLayout"
import { getMeRequest } from "../api/admin-controllers/account-controller"


const AdminRouter = ({ component: Component, ...rest }) => {


    const [AUTH_STATUS, setAUTH_STATUS] = useState("WAITING")



    const checkAuthentication = async () => {

        try {
            let res = await getMeRequest()
            if (res?.data) {
                setTimeout(() => {
                    setAUTH_STATUS("SUCCESS")
                }, 1000);
            }
        } catch (error) {
            if (error?.response?.status === 401) {
                setAUTH_STATUS("FAILED")
            }
        }


    }

    useEffect(() => {
        (
            async () => {
                await checkAuthentication()
            }
        )()
        return () => {

        }
    }, [AUTH_STATUS])



    return (
        <Route  {...rest}>
            {
                AUTH_STATUS === "WAITING" ? <SuspenseFallback />
                    : AUTH_STATUS === "FAILED" ? <Redirect to={{ pathname: "/admin" }} />
                        : AUTH_STATUS === "SUCCESS" ? <AdminPanelLayout> <Component /></AdminPanelLayout>
                            : <div>Error</div>
            }
        </Route>

    )
}

export default AdminRouter